import styles from "./Footer.module.css";

/**
 * Footer — quiet sign-off. Wordmark on the left, a tiny set of links
 * on the right, and a copyright line beneath. No newsletter, no
 * trust-cookies, no social grid.
 */
export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`atlasContainer ${styles.inner}`}>
        <div className={styles.top}>
          <div className={styles.wordmark}>
            <span className={styles.wordmarkBlock}>ATLAS</span>
            <span className={styles.wordmarkBlock}>DESK</span>
          </div>
          <nav className={styles.nav} aria-label="Footer">
            {/* Absolute anchors (`/#section`) so the footer works from
                sub-pages like /stickies — on the homepage browsers
                still treat these as in-page jumps. */}
            <a href="/#philosophy">Philosophy</a>
            <a href="/#environment">Environment</a>
            <a href="/#apps">Apps</a>
            <a href="/#layouts">Layouts</a>
            <a href="/#local">Local-First</a>
            <a href="/#download">Download</a>
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
          </nav>
        </div>
        <div className={styles.rule} aria-hidden />
        <div className={styles.bottom}>
          <p className={styles.note}>
            Made with care.<br/>Software you can put down at the end of the day.
          </p>
          <p className={styles.copy}>© {new Date().getFullYear()} Atlas Desk<br/>Laurel Daigneault</p>
        </div>
      </div>
    </footer>
  );
}
